import React, { useState, useRef, useEffect, useCallback } from 'react';

const Notepad = ({ onClose, isMobile = false }) => {
    const [position, setPosition] = useState({ x: 150, y: 150 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const windowRef = useRef(null);

    const handleTitleBarMouseDown = (e) => {
        if (e.target.classList.contains('window-controls') ||
            e.target.closest('.window-controls')) {
            return;
        }
        setIsDragging(true);
        const rect = windowRef.current.getBoundingClientRect();
        setDragOffset({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        });
    };

    const handleMouseMove = useCallback((e) => {
        if (isDragging) {
            setPosition({
                x: e.clientX - dragOffset.x,
                y: e.clientY - dragOffset.y
            });
        }
    }, [isDragging, dragOffset]);

    const handleMouseUp = useCallback(() => {
        setIsDragging(false);
    }, []);

    useEffect(() => {
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isDragging, handleMouseMove, handleMouseUp]);

    return (
        <div
            ref={windowRef}
            className={`win98-window notepad-window ${isMobile ? 'mobile-fullscreen-window' : ''}`}
            style={isMobile ? {
                position: 'fixed',
                left: 0,
                top: 0,
                width: '100vw',
                height: '100vh',
                transform: 'none',
                zIndex: 1000
            } : {
                position: 'fixed',
                left: position.x,
                top: position.y,
                width: '600px',
                height: '500px',
                zIndex: 1000
            }}
        >
            <div className="window-titlebar" onMouseDown={handleTitleBarMouseDown}>
                <span className="window-title">📝 GOOD VIBES* #ccfc - User Manual</span>
                <div className="window-controls">
                    <button className="minimize-btn">_</button>
                    <button className="maximize-btn">□</button>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
            </div>

            <div className="window-content notepad-content">
                <div className="notepad-text">
                    <h1>📚 GOOD VIBES* #ccfc - How to Use Guide</h1>
                    <p><em>Made with 💅🏻 by #CCFC</em></p>

                    <p>Remember: GOOD VIBES* #ccfc transforms your messages into positive, beautiful words. Be your shiity self and let the AI vibing! ✨</p>


                    <h2>🚀 Getting Started</h2>
                    <p><strong>Step 1:</strong> Double-click the "GOOD VIBES* #ccfc" icon on your desktop</p>
                    <p><strong>Step 2:</strong> Create your account with a name, handle, and 4-digit PIN</p>
                    <p><strong>Step 3:</strong> Start chatting by entering someone's handle!</p>

                    <h2>💬 How to Chat</h2>
                    <p><strong>1. Find Someone:</strong> Enter their handle in the "Chat with" field</p>
                    <p><strong>2. Choose Your Vibe:</strong> Click the "Vibe" button to select your personality</p>
                    <p><strong>3. Type Your Message:</strong> Write whatever you want to say</p>
                    <p><strong>4. Send:</strong> Hit Enter or click Send - the AI will transform it!</p>
                    <p><strong>5. See the Magic:</strong> You see both original + transformed, they only see the good version</p>

                    <h2>🎨 Desktop Basics</h2>
                    <p><strong>🖱️ Drag Icons:</strong> Click and drag any desktop icon to move it</p>
                    <p><strong>🪟 Move Windows:</strong> Drag windows by their title bars</p>
                    <p><strong>🎭 Emoji Board:</strong> Click emoji icon, click emojis to make them float</p>
                    <p><strong>🗑️ Clean Up:</strong> Double-click trash bin to remove floating emojis</p>



                    <h2>🎯 Pro Tips</h2>
                    <p><strong>💡 Quick Login:</strong> If you've used the app before, your handles will appear in the login window</p>
                    <p><strong>💡 Chat History:</strong> Click "Show Chats" to see people you've talked to</p>
                    <p><strong>💡 Start Menu:</strong> Click the Start button to access features</p>
                    <p><strong>💡 Mobile Friendly:</strong> Works great on phones and tablets too!</p>



                    <h2>🔐 Security</h2>
                    <p>Your account is protected with a 4-digit PIN. Choose something you'll remember!</p>
                    <p>If someone else has your handle, you can still log in if you know the PIN.</p>


                    <h2>❓ Need Help?</h2>
                    <p><strong>Find Us</strong> cc-fc.cc</p>
                    <p><strong>Where:</strong> San Francisco, CA</p>
                    <p><strong>Team:</strong> @cc-fc.cc</p>
                    <p><strong>Made in:</strong> 2025.10</p>

                    <h2>🎉 Have Fun!</h2>

                    <p><em>Made with 💅🏻 and lots of good vibes by #CCFC</em></p>
                </div>
            </div>
        </div>
    );
};

export default Notepad;
